<template>
  <div class="paper-policies-box widget">
    <h6>MAILING PAPER POLICIES</h6>
    <div class="row">
      <div class="col-sm-12 col-md-2">
        <img src="@/assets/images/insurecareteams/dashboard/MailingPaperPolicies.png">
      </div>
      <div class="col-sm-12 col-md-10">
        <p>
          To recieve a copy of your policy by mail, contact
          <a
            :href="`mailto: ${details.email_address}`"
          >{{ details.email_address }}</a> or
          <a :href="`tel: ${details.phone_number}`">{{ details.phone_number }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Brand from '@/services/Brand';
export default {
     name: 'PaperPoliciesWidget',
     computed: {
          details() {
               return Brand.getBrandInformation();
          },
     },
};
</script>


<style scoped lang="scss">
.brand-insurecareteams #sidebar .widget {
     background: #e1f7fe;
     border: 1px solid #1f98be;
     border-radius: 10px;
     padding: 20px 18px;

     h6 {
          font-size: 14px;
          line-height: 25px;
          color: #454545;
     }

     p {
          position: relative;
          top: -9px;
          margin-bottom: -9px;
          font-size: 12px;
          line-height: 26px;
     }

     svg {
          width: 50px;
          height: 47px;
          fill: #1f98be;
     }
}
</style>